import { Championship, Organizer } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import { Fouls, Goals, Match, ShootoutScore, Teams } from 'modules/overlay-v2/domain/interfaces/game-info/state';
import {
  selectChampionship,
  selectFormatStartDate,
  selectFoulsByCurrentPeriod,
  selectGoals,
  selectLoading,
  selectMatch,
  selectOrganizer,
  selectShootoutGoals,
  selectShootoutMisses,
  selectSynchronization,
  selectTeams,
} from 'modules/overlay-v2/store/game-info/selectors';

import { useSelector } from 'react-redux';

export interface GameInfo {
  organizer?: Organizer;
  match?: Match;
  championship?: Championship;
  teams?: Teams;
  isSynchronization: boolean;
  isSynchronize: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  goals: Goals;
  fouls: Fouls;
  shootoutGoals: ShootoutScore;
  shootoutMisses: ShootoutScore;
  formatStartDate: {
    date: string;
    time: string;
  };
}

const useGameInfo = (): GameInfo => {
  const organizer = useSelector(selectOrganizer);
  const match = useSelector(selectMatch);
  const championship = useSelector(selectChampionship);
  const teams = useSelector(selectTeams);
  const sync = useSelector(selectSynchronization);
  const load = useSelector(selectLoading);
  const goals = useSelector(selectGoals);
  const shootoutGoals = useSelector(selectShootoutGoals);
  const shootoutMisses = useSelector(selectShootoutMisses);
  const formatStartDate = useSelector(selectFormatStartDate);
  const fouls = useSelector(selectFoulsByCurrentPeriod);

  return {
    organizer,
    match,
    championship,
    teams,
    ...sync,
    ...load,
    goals,
    fouls,
    shootoutGoals,
    shootoutMisses,
    formatStartDate,
  };
};

export default useGameInfo;
